<template>
  <div class="modal attendance">
    <div class="modal__wrapper">
      <button class="close modal__close" @click="$emit('on-close')">
        <fa-icon icon="times"></fa-icon>
      </button>
      <div class="modal__title">Chauffeurs</div>
      <div class="modal__body">
        <div class="attendance__picker">
          <label for="name">Naam</label>
          <input type="text" class="input" v-model="naam" />
        </div>
        <div
          id="attendance"
          class="attendance__data"
          v-if="driverData && driverData.length"
        >
          <table class="table">
            <thead>
              <tr class="table__header">
                <th
                  class="table__header__column"
                  v-for="key in Object.keys(driverData[0])"
                  :key="`driver-header--${key}`"
                >
                  {{ key }}
                </th>
              </tr>
            </thead>
            <tbody class="table__body">
              <tr
                class="table__body__item"
                v-for="(item, index) in filteredList"
                :key="`driver-item--${index}`"
              >
                <td
                  class="table__body__item__column"
                  v-for="key in Object.keys(item)"
                  :key="`driver--${index}-${key}`"
                >
                  {{ item[key] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DriverList",

  data() {
    return {
      driverData: null,
      naam: "",
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    date() {
      this.fetchData();
    },
  },

  computed: {
    filteredList() {
      if (this.driverData && this.naam?.trim() !== "") {
        return this.driverData.filter(
          (d) =>
            `${d.familienaam} ${d.voornaam}`
              .toLowerCase()
              .match(this.naam.toLowerCase()) ||
            `${d.voornaam} ${d.familienaam}`
              .toLowerCase()
              .match(this.naam.toLowerCase())
        );
      }
      return this.driverData;
    },
  },

  methods: {
    async fetchData() {
      this.driverData = [];
      try {
        this.driverData = await this.$store.dispatch("dispatch/getDriverList");
      } catch (e) {
        alert(e);
      }
    },
  },
};
</script>
<style scoped>
.modal__wrapper{
  width: 100%;
  max-width: 1200px;
}
</style>